import { Grid } from '@mantine/core';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoaderSpinner from '../LazyLoaderSpinner';

const segmentStats = ({ stats, segment, currency }) => {
  if (!stats) {
    return (
      <Grid.Col span={12}>
        <LazyLoaderSpinner />
      </Grid.Col>
    );
  }

  return (
    <>
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic title="Opened" stats={stats} stat="opened" id={segment.id} statKey="count" />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic title="Clicks" stats={stats} stat="clicks" id={segment.id} statKey="count" />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Conversions"
              stats={stats}
              stat="conversions"
              percentageOfStat="clicks"
              id={segment.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Purchases"
              stats={stats}
              stat="purchases"
              percentageOfStat="conversions"
              id={segment.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Revenue"
              stats={stats}
              stat="purchases"
              id={segment.id}
              statKey="value"
              currency={currency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px solid #ededed' }}>
            <HeaderStatistic title="Unsubscribes" stats={stats} stat="unsubscribes" id={segment.id} statKey="count" />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </>
  );
};

export default segmentStats;
